// src/pages/attendance/config/translations.js

export const translations = {
  ar: {
    pageTitle: "نظام الحضور والانصراف",
    timeTracker: {
      checkIn: "تسجيل الحضور", checkOut: "تسجيل الانصراف",
      alreadyCheckedIn: "تم تسجيل الحضور بالفعل", notCheckedIn: "لم يتم تسجيل الحضور",
      processingCheckIn: "جاري تسجيل الحضور...", processingCheckOut: "جاري تسجيل الانصراف...",
      inZone: "داخل منطقة العمل", outOfZone: "خارج منطقة العمل",
      locationError: "خطأ في تحديد الموقع", tryAgain: "حاول مرة أخرى",
      refreshLocation: " تحديث الموقع", refreshing: " جاري التحديث...",
      distanceToCenter: "المسافة من المركز",
      loadingLocation: "جاري تحميل موقع العمل...", gettingLocation: "جاري تحديد موقعك...",
      withinZone: " داخل المنطقة", outZone: " خارج المنطقة",
    },
    stats: {
      presentDays: "أيام الحضور", absentDays: "أيام الغياب",
      lateArrivals: "مرات التأخير", totalHours: "إجمالي الساعات", thisMonth: "هذا الشهر",
    },
    weekDays: {
      Sunday: "الأحد", Monday: "الاثنين", Tuesday: "الثلاثاء", Wednesday: "الأربعاء",
      Thursday: "الخميس", Friday: "الجمعة", Saturday: "السبت",
    },
    weekly: {
      title: "حضور هذا الأسبوع", weekend: "عطلة", restDay: "يوم راحة",
      in: "دخول:", out: "خروج:", present: "حاضر", absent: "غائب", late: "متأخر",
      summary: "ملخص الأداء الأسبوعي", presentDaysCount: "أيام الحضور",
      lateArrivalsCount: "مرات التأخير", absentDaysCount: "أيام الغياب", totalHoursCount: "إجمالي الساعات",
    },
    performance: {
      title: "مقاييس الأداء", attendanceRate: "معدل الحضور", punctuality: "الالتزام بالمواعيد",
      avgHoursPerDay: "متوسط الساعات/اليوم", overtimeHours: "ساعات إضافية",
      current: "الحالي:", target: "الهدف:",
    },
    monthly: {
      title: "سجل الحضور الشهري", month: "الشهر", presentDays: "أيام الحضور",
      absentDays: "أيام الغياب", lateDays: "أيام التأخير", totalDays: "إجمالي الأيام",
      attendanceRate: "معدل الحضور", performance: "الأداء",
    },
    recent: {
      title: "السجلات الأخيرة", date: "التاريخ", checkIn: "وقت الدخول",
      checkOut: "وقت الخروج", totalHours: "إجمالي الساعات", status: "الحالة", complete: "مكتمل",
    },
    status: { present: "حاضر", absent: "غائب", late: "متأخر", weekend: "عطلة", Complete: "مكتمل", onLeave: "في إجازة", leave: "في إجازة", "On Leave": "في إجازة", rest_day: "يوم راحة", "Rest Day": "يوم راحة", holiday: "إجازة رسمية", half_day: "نصف يوم" },
    units: { hours: "ساعة", meters: "متر" },
    workFromHome: {
      requestButton: "طلب العمل من المنزل", modalTitle: "طلب العمل من المنزل",
      selectDate: "اختر التاريخ", reason: "سبب الطلب",
      reasonPlaceholder: "اكتب سبب طلب العمل من المنزل...",
      submit: "إرسال الطلب", cancel: "إلغاء", submitting: "جاري الإرسال...",
      success: "تم إرسال طلب العمل من المنزل بنجاح", error: "فشل في إرسال الطلب",
      pending: "طلب العمل من المنزل قيد الانتظار", approved: "تمت الموافقة على العمل من المنزل",
      rejected: "تم رفض طلب العمل من المنزل", workingFromHome: "تعمل من المنزل اليوم",
      locationBypassed: "اشتغل من البيت",
    },
    locationIssues: {
      NO_WORK_LOCATION: {
        title: "لم يتم تحديد موقع عمل لك",
        hint: "لا يوجد موقع عمل مسجّل لك اليوم، لذلك لا يمكن تسجيل الحضور. تواصل مع الموارد البشرية أو مديرك المباشر لإضافة موقع العمل، أو قدّم طلب عمل من المنزل.",
      },
      EMPLOYEE_NOT_FOUND: {
        title: "لم يتم العثور على ملفك الوظيفي",
        hint: "حسابك غير مربوط بملف موظف، لذلك لا يمكن تحديد موقع عملك. تواصل مع الموارد البشرية.",
      },
      MISSING_EMPLOYEE_CODE: {
        title: "حسابك غير مربوط بكود موظف",
        hint: "لا يمكن تحميل موقع عملك بدون كود الموظف. تواصل مع الموارد البشرية لربط حسابك.",
      },
      AREA_LOAD_FAILED: {
        title: "تعذّر تحميل موقع العمل",
        hint: "حدثت مشكلة في الاتصال بالخادم. تأكد من اتصالك بالإنترنت ثم حاول مرة أخرى.",
      },
      PERMISSION_DENIED: {
        title: "الوصول إلى موقعك مرفوض",
        hint: "المتصفح غير مسموح له بمعرفة موقعك. فعّل الإذن بالخطوات التالية ثم اضغط «حاول مرة أخرى».",
        steps: ["أيقونة القفل بجوار العنوان", "إعدادات الموقع", "الموقع ← سماح"],
      },
      POSITION_UNAVAILABLE: {
        title: "تعذّر تحديد موقعك",
        hint: "خدمة تحديد الموقع على جهازك مغلقة أو الإشارة غير متاحة.",
        steps: ["إعدادات الجهاز", "الخصوصية ← الموقع", "تشغيل خدمة الموقع"],
      },
      TIMEOUT: {
        title: "استغرق تحديد موقعك وقتًا طويلًا",
        hint: "إشارة الموقع ضعيفة. اقترب من نافذة أو اتصل بشبكة Wi-Fi ثم حاول مرة أخرى.",
      },
      UNSUPPORTED: {
        title: "المتصفح لا يدعم تحديد الموقع",
        hint: "استخدم متصفحًا حديثًا مثل Chrome أو Edge أو Safari لتسجيل الحضور.",
      },
      INSECURE_CONTEXT: {
        title: "تحديد الموقع غير متاح على هذا الرابط",
        hint: "المتصفحات تسمح بتحديد الموقع فقط على اتصال آمن (https). افتح النظام من الرابط الآمن أو تواصل مع الدعم الفني.",
      },
    },
    locationIssueOwners: {
      you: "مطلوب منك", hr: "مطلوب من الموارد البشرية",
      support: "مطلوب من الدعم الفني", connection: "مشكلة اتصال",
    },
    // ── Face check-in (shared by the attendance page, the profile enrollment
    //    section and the admin employee table) ──
    face: {
      title: "تسجيل الحضور بالوجه",
      checkInTitle: "تسجيل الحضور بالوجه",
      checkOutTitle: "تسجيل الانصراف بالوجه",
      useFace: "استخدام الوجه",
      useFaceHint: "يمكنك تسجيل الحضور أو الانصراف بوجهك بدلاً من الطريقة المعتادة.",
      setupHint: "فعّل تسجيل الحضور بالوجه من البطاقة أدناه.",
      serviceDownNotice: "خدمة التحقق بالوجه غير متاحة مؤقتًا، يتم تسجيل الحضور والانصراف بالطريقة المعتادة حتى تعود.",
      getReady: "استعد… ضع وجهك داخل الإطار",
      prompts: { left: "انظر إلى اليسار", center: "انظر إلى الكاميرا", right: "انظر إلى اليمين" },
      enrolPrompts: {
        straight: "انظر مباشرةً إلى الكاميرا",
        left: "أدر وجهك قليلاً إلى اليسار",
        right: "أدر وجهك قليلاً إلى اليمين",
      },
      capturing: "جارٍ التصوير…",
      verifying: "جارٍ التحقق من الوجه…",
      startCamera: "تشغيل الكاميرا",
      startingCamera: "جارٍ تشغيل الكاميرا…",
      cameraDenied: "تم رفض الوصول إلى الكاميرا. اسمح باستخدام الكاميرا من إعدادات المتصفح ثم حاول مرة أخرى.",
      cameraUnavailable: "لم يتم العثور على كاميرا في هذا الجهاز، أو أن المتصفح لا يسمح بالكاميرا عبر هذا الرابط.",
      cameraError: "تعذّر تشغيل الكاميرا. حاول مرة أخرى.",
      retry: "حاول مرة أخرى",
      cancel: "إلغاء",
      close: "إغلاق",
      attemptsLeftHint: "لم يتم التعرّف على الوجه. حاول مرة أخرى في إضاءة أفضل.",
      fallbackHint: "تواجه مشكلة؟ يمكنك التسجيل بالطريقة المعتادة.",
      requiredNoFallback: "تطلب شركتك التحقق بالوجه. حاول مرة أخرى في إضاءة أفضل، أو تواصل مع الموارد البشرية إذا تعذّر استخدام الكاميرا.",
      fallbackIn: "تسجيل الحضور بدون الوجه",
      fallbackOut: "تسجيل الانصراف بدون الوجه",
      fallbackRecordedIn: "تم تسجيل الحضور بدون التحقق بالوجه وستراجعه الموارد البشرية",
      fallbackRecordedOut: "تم تسجيل الانصراف بدون التحقق بالوجه وستراجعه الموارد البشرية",
      moveCloser: "اقترب من الكاميرا",
      moveBack: "ابتعد قليلاً عن الكاميرا",
      verifiedIn: "تم التحقق من وجهك وتسجيل الحضور",
      verifiedOut: "تم التحقق من وجهك وتسجيل الانصراف",
      serviceDownIn: "خدمة التحقق بالوجه غير متاحة، تم تسجيل الحضور برمز PIN",
      serviceDownOut: "خدمة التحقق بالوجه غير متاحة، تم تسجيل الانصراف برمز PIN",
      refusedTitle: "تعذّر التحقق من الوجه",
      failedTitle: "خطأ",
      genericError: "تعذّر إتمام التحقق بالوجه. يرجى المحاولة مرة أخرى.",
      enrolRequiredTitle: "يلزم تسجيل الوجه أولاً",
      enrolRequiredBody: "تطلب شركتك تسجيل الحضور بالوجه. سجّل وجهك أولاً من بطاقة «تسجيل الحضور بالوجه» أسفل أزرار الحضور.",
      goToProfile: "تسجيل الوجه",
      codes: {
        identity_inconsistent: "الوجه في اللقطات غير متطابق. ثبّت وجهك داخل الإطار وحاول مرة أخرى.",
        retry_exhausted: "تم تجاوز عدد المحاولات المسموح بها. استخدم الطريقة المعتادة أو حاول لاحقاً.",
        no_head_motion: "لم يتم رصد حركة للرأس. حرّك رأسك يميناً ويساراً أثناء التصوير.",
        spoof_texture: "لم يتم التأكد من أن الصورة لوجه حقيقي. استخدم وجهك مباشرةً أمام الكاميرا وليس صورة أو شاشة.",
        no_face: "لم يتم العثور على وجه في الصورة. ضع وجهك داخل الإطار.",
        multiple_faces: "تم رصد أكثر من وجه. تأكد من وجودك وحدك أمام الكاميرا.",
        face_too_small: "الوجه صغير جداً في الصورة. اقترب من الكاميرا.",
        bad_image: "الصورة غير واضحة. تأكد من الإضاءة ونظافة الكاميرا وحاول مرة أخرى.",
        reenrol_required: "يلزم تحديث تسجيل وجهك. سجّل وجهك مرة أخرى من ملفك الشخصي.",
        service_down: "خدمة التحقق بالوجه غير متاحة حالياً.",
        fallback_disabled_required: "تطلب شركتك التحقق بالوجه ولا يوجد تسجيل حضور بدونه. حاول مرة أخرى أو تواصل مع الموارد البشرية.",
        face_token_invalid: "انتهت صلاحية التحقق بالوجه أو تم استخدامه بالفعل. يرجى التحقق من وجهك مرة أخرى.",
        already_enrolled: "وجهك مسجَّل بالفعل. اطلب من الموارد البشرية إعادة ضبط التسجيل إذا لزم الأمر.",
        face_required: "تطلب شركتك التحقق بالوجه لتسجيل الحضور والانصراف. استخدم تسجيل الحضور بالوجه.",
        face_enrol_required: "تطلب شركتك تسجيل الحضور بالوجه. سجّل وجهك من ملفك الشخصي أولاً.",
        fallback_not_allowed: "التسجيل بدون الوجه متاح فقط بعد فشل التحقق بالوجه مرتين.",
        challenge_mismatch: "لم يتم تحريك الرأس بالترتيب المطلوب. اتبع التعليمات على الشاشة (يسار/يمين) وحاول مرة أخرى.",
        challenge_expired: "استغرقت المحاولة وقتاً طويلاً. ابدأ التحقق بالوجه من جديد.",
        challenge_required: "تعذّر بدء محاولة التحقق. حاول مرة أخرى.",
      },
      // consent
      consentTitle: "الموافقة على تسجيل الحضور بالوجه",
      consentIntro: "قبل تسجيل وجهك، يرجى قراءة ما يلي والموافقة عليه.",
      consentPoints: [
        "نحتفظ بقالب رقمي مشفّر لوجهك (ليس صورة) لاستخدامه في التحقق من هويتك عند تسجيل الحضور والانصراف.",
        "تُستخدم الصور التي تلتقطها للتحقق فقط ولا تُخزَّن بعد المعالجة.",
        "يمكنك طلب حذف تسجيل وجهك من الموارد البشرية في أي وقت.",
      ],
      // TODO-legal: placeholder wording until the legal team supplies the final notice.
      consentLegal: "[نص قانوني مبدئي – TODO-legal] أوافق على معالجة بيانات وجهي البيومترية لغرض تسجيل الحضور والانصراف وفقاً لسياسة الخصوصية، وأعلم أن بإمكاني سحب هذه الموافقة في أي وقت.",
      privacyLink: "إشعار الخصوصية",
      agree: "أوافق",
      agreeing: "جارٍ الحفظ…",
      notNow: "ليس الآن",
      consentFailed: "تعذّر حفظ الموافقة. يرجى المحاولة مرة أخرى.",
      // enrollment
      enrolTitle: "تسجيل الوجه",
      enrolSubtitle: "سجّل وجهك مرة واحدة بثلاث صور، ثم سجّل حضورك بوجهك.",
      shotOf: "الصورة {n} من 3",
      takePhoto: "التقاط",
      retake: "إعادة",
      submitEnrol: "حفظ التسجيل",
      submitting: "جارٍ الحفظ…",
      enrolSuccess: "تم تسجيل وجهك بنجاح",
      enrolFailed: "تعذّر تسجيل الوجه",
      enrolRejectedHint: "رُفضت إحدى الصور. أعد التقاطها ثم حاول الحفظ مرة أخرى.",
      statusLabel: "الحالة",
      enrolled: "مسجَّل",
      notEnrolled: "غير مسجَّل",
      consented: "تمت الموافقة",
      notConsented: "بانتظار الموافقة",
      modelOutdated: "يلزم إعادة التسجيل",
      enrol: "تسجيل الوجه",
      reenrol: "إعادة التسجيل",
      modeOptional: "اختياري",
      modeRequired: "إلزامي",
      modeLabel: "تسجيل الحضور بالوجه في شركتك: {mode}",
      enrolledLocked: "وجهك مسجَّل. لإعادة التسجيل اطلب من الموارد البشرية إعادة ضبط تسجيل وجهك.",
      enrolRequiredHint: "سجّل وجهك مرة واحدة لتتمكن من تسجيل الحضور والانصراف.",
      enrolOptionalHint: "سجّل وجهك مرة واحدة لتسجيل الحضور والانصراف بوجهك بدلاً من الطريقة المعتادة.",
      loading: "جارٍ التحميل…",
      // admin employee table
      adminColumn: "تسجيل الوجه",
      adminEnrolled: "مسجَّل",
      adminNotEnrolled: "غير مسجَّل",
      adminReset: "إعادة التسجيل",
      adminResetTitle: "إعادة تسجيل الوجه",
      adminResetConfirm: "سيتم حذف تسجيل الوجه الخاص بـ {name} وسيلزمه التسجيل مرة أخرى. هل تريد المتابعة؟",
      adminResetDone: "تم حذف تسجيل الوجه. على الموظف تسجيل وجهه مرة أخرى.",
      adminResetFailed: "تعذّر حذف تسجيل الوجه.",
    },
  },
  en: {
    pageTitle: "Attendance System",
    timeTracker: {
      checkIn: "Check In", checkOut: "Check Out",
      alreadyCheckedIn: "Already Checked In", notCheckedIn: "Not Checked In",
      processingCheckIn: "Processing Check In...", processingCheckOut: "Processing Check Out...",
      inZone: "Inside Work Zone", outOfZone: "Outside Work Zone",
      locationError: "Location Error", tryAgain: "Try Again",
      refreshLocation: " Refresh Location", refreshing: " Refreshing...",
      distanceToCenter: "Distance from Center",
      loadingLocation: "Loading work location...", gettingLocation: "Getting your location...",
      withinZone: " Within Zone", outZone: " Outside Zone",
    },
    stats: {
      presentDays: "Present Days", absentDays: "Absent Days",
      lateArrivals: "Late Arrivals", totalHours: "Total Hours", thisMonth: "This Month",
    },
    weekDays: {
      Sunday: "Sunday", Monday: "Monday", Tuesday: "Tuesday", Wednesday: "Wednesday",
      Thursday: "Thursday", Friday: "Friday", Saturday: "Saturday",
    },
    weekly: {
      title: "This Week's Attendance", weekend: "Weekend", restDay: "Rest Day",
      in: "In:", out: "Out:", present: "Present", absent: "Absent", late: "Late",
      summary: "Weekly  Summary", presentDaysCount: "Present Days",
      lateArrivalsCount: "Late Arrivals", absentDaysCount: "Absent Days", totalHoursCount: "Total Hours",
    },
    performance: {
      title: "Performance Metrics", attendanceRate: "Attendance Rate", punctuality: "Punctuality",
      avgHoursPerDay: "Avg Hours/Day", overtimeHours: "Overtime Hours",
      current: "Current:", target: "Target:",
    },
    monthly: {
      title: "Monthly Attendance Record", month: "Month", presentDays: "Present Days",
      absentDays: "Absent Days", lateDays: "Late Days", totalDays: "Total Days",
      attendanceRate: "Attendance Rate", performance: "Performance",
    },
    recent: {
      title: "Recent Records", date: "Date", checkIn: "Check In Time",
      checkOut: "Check Out Time", totalHours: "Total Hours", status: "Status", complete: "Complete",
    },
    status: { present: "Present", absent: "Absent", late: "Late", weekend: "Weekend", Complete: "Complete", onLeave: "On Leave", leave: "On Leave", "On Leave": "On Leave", rest_day: "Rest Day", "Rest Day": "Rest Day", holiday: "Holiday", half_day: "Half Day" },
    units: { hours: "hours", meters: "m" },
    workFromHome: {
      requestButton: "Request Work From Home", modalTitle: "Work From Home Request",
      selectDate: "Select Date", reason: "Reason for Request",
      reasonPlaceholder: "Enter reason for working from home...",
      submit: "Submit Request", cancel: "Cancel", submitting: "Submitting...",
      success: "Work from home request submitted successfully", error: "Failed to submit request",
      pending: "Work from home request pending", approved: "Work from home approved",
      rejected: "Work from home request rejected", workingFromHome: "Working from home today",
      locationBypassed: "Location check bypassed",
    },
    locationIssues: {
      NO_WORK_LOCATION: {
        title: "No work location assigned to you",
        hint: "There is no work location set for you today, so check-in isn't possible. Ask HR or your manager to add your work location, or submit a work-from-home request.",
      },
      EMPLOYEE_NOT_FOUND: {
        title: "Employee record not found",
        hint: "Your account isn't linked to an employee record, so your work location can't be loaded. Please contact HR.",
      },
      MISSING_EMPLOYEE_CODE: {
        title: "Your account has no employee code",
        hint: "Your work location can't be loaded without an employee code. Please contact HR to link your account.",
      },
      AREA_LOAD_FAILED: {
        title: "Couldn't load your work location",
        hint: "There was a problem reaching the server. Check your internet connection and try again.",
      },
      PERMISSION_DENIED: {
        title: "Location access is blocked",
        hint: "Your browser isn't allowed to read your location. Allow it with these steps, then press Try again.",
        steps: ["Lock icon by the address bar", "Site settings", "Location → Allow"],
      },
      POSITION_UNAVAILABLE: {
        title: "Your location couldn't be determined",
        hint: "Location services on your device are off or no signal is available.",
        steps: ["Device settings", "Privacy → Location", "Turn location on"],
      },
      TIMEOUT: {
        title: "Finding your location took too long",
        hint: "The location signal is weak. Move closer to a window or connect to Wi-Fi, then try again.",
      },
      UNSUPPORTED: {
        title: "This browser doesn't support location",
        hint: "Use an up-to-date browser such as Chrome, Edge or Safari to check in.",
      },
      INSECURE_CONTEXT: {
        title: "Location isn't available on this link",
        hint: "Browsers only share your location over a secure (https) connection. Open the system from its secure link or contact IT support.",
      },
    },
    locationIssueOwners: {
      you: "Action needed from you", hr: "Handled by HR",
      support: "Handled by IT support", connection: "Connection issue",
    },
    // ── Face check-in (shared by the attendance page, the profile enrollment
    //    section and the admin employee table) ──
    face: {
      title: "Face check-in",
      checkInTitle: "Face check-in",
      checkOutTitle: "Face check-out",
      useFace: "Use face",
      useFaceHint: "You can check in or out with your face instead of the regular punch.",
      setupHint: "Set up face check-in from the card below.",
      serviceDownNotice: "Face verification is temporarily unavailable; the regular check-in/out is in use until it is back.",
      getReady: "Get ready… keep your face inside the frame",
      prompts: { left: "Look left", center: "Face the camera", right: "Look right" },
      enrolPrompts: {
        straight: "Look straight at the camera",
        left: "Turn slightly to the left",
        right: "Turn slightly to the right",
      },
      capturing: "Capturing…",
      verifying: "Verifying your face…",
      startCamera: "Start camera",
      startingCamera: "Starting camera…",
      cameraDenied: "Camera access was blocked. Allow the camera in your browser settings and try again.",
      cameraUnavailable: "No camera was found on this device, or the browser does not allow the camera on this link.",
      cameraError: "The camera could not be started. Please try again.",
      retry: "Try again",
      cancel: "Cancel",
      close: "Close",
      attemptsLeftHint: "Your face was not recognised. Try again in better light.",
      fallbackHint: "Having trouble? Use the regular punch instead.",
      requiredNoFallback: "Your company requires face verification. Try again in better light, or contact HR if the camera cannot be used.",
      fallbackIn: "Check in without face",
      fallbackOut: "Check out without face",
      fallbackRecordedIn: "Checked in without face verification; HR will review it",
      fallbackRecordedOut: "Checked out without face verification; HR will review it",
      moveCloser: "Move closer",
      moveBack: "Move back",
      verifiedIn: "Face verified — checked in",
      verifiedOut: "Face verified — checked out",
      serviceDownIn: "Face check unavailable, checked in with PIN",
      serviceDownOut: "Face check unavailable, checked out with PIN",
      refusedTitle: "Face check failed",
      failedTitle: "Error",
      genericError: "The face check could not be completed. Please try again.",
      enrolRequiredTitle: "Face enrollment required",
      enrolRequiredBody: "Your company requires face check-in. Enroll your face first from the card below the check-in buttons.",
      goToProfile: "Enroll your face",
      codes: {
        identity_inconsistent: "The face differs between frames. Hold still inside the frame and try again.",
        retry_exhausted: "Too many attempts. Use the regular punch or try again later.",
        no_head_motion: "No head movement was detected. Turn your head left and right while capturing.",
        spoof_texture: "We could not confirm a live face. Use your own face in front of the camera, not a photo or a screen.",
        no_face: "No face was found in the picture. Keep your face inside the frame.",
        multiple_faces: "More than one face was detected. Make sure you are alone in front of the camera.",
        face_too_small: "Your face is too small in the picture. Move closer to the camera.",
        bad_image: "The picture is not clear. Check the lighting and the camera lens, then try again.",
        reenrol_required: "Your face enrollment needs to be renewed. Please enroll again from your profile.",
        service_down: "The face verification service is currently unavailable.",
        fallback_disabled_required: "Your company requires face verification; there is no check-in without it. Try again or contact HR.",
        face_token_invalid: "Your face verification has expired or was already used. Please verify your face again.",
        already_enrolled: "Your face is already enrolled. Ask HR to reset your enrollment if it needs redoing.",
        face_required: "Your company requires face verification to check in and out. Use the face check-in.",
        face_enrol_required: "Your company requires face check-in. Enroll your face from your profile first.",
        fallback_not_allowed: "Checking in without face is only available after the face check failed twice.",
        challenge_mismatch: "Your head did not turn in the order asked. Follow the on-screen prompts (left/right) and try again.",
        challenge_expired: "The attempt took too long. Start the face check again.",
        challenge_required: "The attempt could not be started. Please try again.",
      },
      // consent
      consentTitle: "Face check-in consent",
      consentIntro: "Before enrolling your face, please read and agree to the following.",
      consentPoints: [
        "We keep an encrypted numeric template of your face (not a photo) to verify your identity when you check in or out.",
        "The pictures you take are used for verification only and are not stored after processing.",
        "You can ask HR to delete your face enrollment at any time.",
      ],
      // TODO-legal: placeholder wording until the legal team supplies the final notice.
      consentLegal: "[Placeholder legal text – TODO-legal] I agree to the processing of my biometric face data for the purpose of recording my attendance, in line with the privacy notice, and I understand that I can withdraw this consent at any time.",
      privacyLink: "Privacy notice",
      agree: "Agree",
      agreeing: "Saving…",
      notNow: "Not now",
      consentFailed: "Your consent could not be saved. Please try again.",
      // enrollment
      enrolTitle: "Face enrollment",
      enrolSubtitle: "Enroll once with three photos, then check in with your face.",
      shotOf: "Photo {n} of 3",
      takePhoto: "Take photo",
      retake: "Retake",
      submitEnrol: "Save enrollment",
      submitting: "Saving…",
      enrolSuccess: "Your face was enrolled successfully",
      enrolFailed: "Face enrollment failed",
      enrolRejectedHint: "One of the photos was rejected. Retake it and save again.",
      statusLabel: "Status",
      enrolled: "Enrolled",
      notEnrolled: "Not enrolled",
      consented: "Consent given",
      notConsented: "Consent pending",
      modelOutdated: "Re-enrollment needed",
      enrol: "Enroll face",
      reenrol: "Re-enroll",
      modeOptional: "optional",
      modeRequired: "required",
      modeLabel: "Face check-in at your company: {mode}",
      enrolledLocked: "Your face is enrolled. To enroll again, ask HR to reset your face enrollment.",
      enrolRequiredHint: "Enroll once to be able to check in and out.",
      enrolOptionalHint: "Enroll once to check in and out with your face instead of the regular punch.",
      loading: "Loading…",
      // admin employee table
      adminColumn: "Face enrollment",
      adminEnrolled: "Enrolled",
      adminNotEnrolled: "Not enrolled",
      adminReset: "Re-enroll",
      adminResetTitle: "Reset face enrollment",
      adminResetConfirm: "This removes the face enrollment of {name}; they will have to enroll again. Continue?",
      adminResetDone: "Face enrollment reset. The employee must enroll again.",
      adminResetFailed: "Could not reset the face enrollment.",
    },
  },
};